export default __webpack_public_path__ + "static/media/b53.5d12a995.png";